<template>
    <div>
        <div :class="preCls + 'content-box'">
            <table-tool-bar>
                <template slot="left">
                    <table-searcher
                        v-model="filter.search"
                        placeholder="请输入配套名称"
                        style="margin-left: 10px"
                        @search="search"
                    ></table-searcher>
                </template>
                <Button
                    :class="preCls + 'button-margin'"
                    v-if="$can('add')"
                    :disabled="loading"
                    type="primary"
                    @click="onClickAdd"
                    >新增配套</Button
                >
            </table-tool-bar>
            <Table
                ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight"
            >
                <!-- 操作列 -->
                <template v-slot:action="{ row }">
                    <Button
                        v-if="$can('view')"
                        type="default"
                        size="small"
                        style="margin-right: 5px"
                        @click="rowClickView(row)"
                    >
                        详情
                    </Button>
                    <Button
                        v-if="$can('update')"
                        type="default"
                        size="small"
                        style="margin-right: 5px"
                        @click="rowClickUpdate(row)"
                    >
                        修改
                    </Button>
                    <PoptipButton
                        v-if="$can('delete')"
                        text="删除"
                        transfer
                        placement="top-end"
                        type="default"
                        title="确认删除此条配套设施吗？"
                        :ok="() => rowClickDelete(row)"
                    />
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager
                :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"
            ></table-pager>
            <!-- 弹出层 -->
            <smart-modal
                v-model="modal.showAFInfoForm"
                :title="actionTitle + '配套'"
                :width="800"
                :height="600"
                :maskClosable="false"
                @close-by-confirm="search"
            >
                <a-f-info-form
                    v-if="modal.showAFInfoForm"
                    :id="curId"
                    :actionType="actionType"
                />
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { currency } from 'es-sharp'
import AFInfoForm from './a-f-info-form'
import {
    assetsFacilityListNoChildren,
    assetsFacilityDelete,
} from '@/api/assets'

export default {
    name: 'a-f-info-list',

    components: {
        AFInfoForm,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            curId: '',
            actionType: '', // 1 新增; 2 查看; 3 修改;
            page: {
                total: 0,
                list: [],
            },
            modal: {
                showAFInfoForm: false,
            },
            dict: {
                actionType: this.$dict.NULL,
            },
        }
    },

    computed: {
        ...mapCache({
            filter: 'assetsFacilityIndex',
        }),

        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'title',
                    title: '配套名称',
                    align: 'left',
                    minWidth: 100,
                },
                {
                    key: 'num',
                    title: '配套总数(个)',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'childrenTitles',
                    title: '品牌参数',
                    align: 'left',
                    minWidth: 500,
                    ellipsis: true,
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },

        actionTitle() {
            return this.dict.actionType.val(this.actionType)
        },
    },

    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                assetsFacilityListNoChildren(this.filter),
                this.$dict.get(['action_type']),
            ])
                .then((args) => {
                    var [page, group] = args

                    Object.assign(this.dict, group)

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            var list = data.page.list

            list.forEach((v) => {
                var children = JSON.safeParse(v.childrenStr) || []

                v.childrenTitles = children
                    .reduce((acc, p) => {
                        var [title = null, price = null] = p || []

                        if (title !== null && price !== null) {
                            acc.push(title + ' ' + currency(price / 100) + '元')
                        }

                        return acc
                    }, [])
                    .join(',')
            })
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd() {
            this.actionType = '1'
            this.curId = ''
            this.modal.showAFInfoForm = true
        },

        rowClickView(row) {
            this.actionType = '2'
            this.curId = row.id
            this.modal.showAFInfoForm = true
        },

        rowClickUpdate(row) {
            this.actionType = '3'
            this.curId = row.id
            this.modal.showAFInfoForm = true
        },

        rowClickDelete(row) {
            assetsFacilityDelete(row.id)
                .then(() => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        },
    },
}
</script>
<style lang="less" scoped></style>
